import React from 'react';
import { useUserState } from '../../hooks/useUserState';

interface UserAvatarProps {
  className?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ className = '' }) => {
  const { email } = useUserState();
  
  const getLetterFromEmail = (email: string | null): string => {
    if (!email) return 'u'; // Default to 'u' for unknown/guest users
    return email.charAt(0).toLowerCase();
  };

  const letter = getLetterFromEmail(email);

  return (
    <span className={`overflow-hidden rounded-full h-11 w-11 ${className}`}>
      <img src={`./images/letters/letter-${letter}.svg`} alt={`User ${letter.toUpperCase()}`} />
    </span>
  );
};